import {
  Users, Building, Warehouse, Package,
  FileText, ShoppingCart, User, Landmark,
  Briefcase, Boxes, LayoutDashboard, Key, ClipboardList,
  UserCircle, Coins, Receipt, ArrowLeftRight,
  DollarSign, Users2Icon, Settings2, LucideWarehouse,
  UndoDotIcon, BarChart3, Wallet, CardSimIcon, History,
  BrickWallShieldIcon, PersonStanding, Settings, PackageSearch,
  MapPin, CalendarRange, ClipboardCheck,
  BanknoteX, AppWindow,
  Tag,
  Printer,
  ReceiptTurkishLira,
  Gauge,
  Scale,
  CreditCard,
  Truck,
  PackageCheck
} from "lucide-react";

interface MenuItem {
  label: string;
  path: string;
  icon: React.ElementType;
  module?: string;
}

interface MenuGroup {
  title?: string;
  items: MenuItem[];
}

type MenuConfig = Record<string, MenuGroup[]>;

// --- 1. FIRM_ADMIN Menü Parçaları ---

const firmAdminDashboardMenu: MenuGroup[] = [
  {
    items: [
      { label: "Dashboard", path: "/firm/dashboard", icon: LayoutDashboard },
    ]
  },
];

const firmAdminOperationsAndDefinitionsMenu: MenuGroup[] = [
  {
    title: "Hareketler",
    items: [
      { label: "Faturalar", path: "/firm/invoices", icon: Receipt, module: "invoiceModule" },
      { label: "İrsaliyeler", path: "/firm/despatch", icon: ReceiptTurkishLira, module: "invoiceModule" },
      { label: "Tahsilat & Ödeme", path: "/firm/collections-payments", icon: DollarSign, module: "paymentModule" },
      { label: "Siparişler", path: "/firm/orders", icon: ShoppingCart, module: "orderModule" },
      { label: "Kullanıcılar", path: "/firm/users", icon: Users2Icon, module: "userModule" },
    ]
  },
  {
    title: "Depo Operasyonları", // Yeni ana grup
    items: [
      {
        label: "Operasyon Paneli",
        path: "/firm/warehouses/monitor",
        icon: LayoutDashboard, // Monitör/Dashboard vurgusu için
        module: "warehouseModule"
      },
      {
        label: "Ürün Toplama & Takip",
        path: "/firm/warehouses/item-tracking",
        icon: PackageCheck,
        module: "warehouseModule"
      },
      {
        label: "Canlı Ekran (Live)",
        path: "/firm/warehouses/live-monitor",
        icon: AppWindow, 
        module: "warehouseModule"
      },
      {
        label: "Eksik Listesi & Stok",
        path: "/firm/warehouses/shortage-monitor",
        icon: PackageSearch, // Eksik ürün arama/bulma vurgusu
        module: "warehouseModule"
      },
      {
        label: "Personel İş Geçmişi",
        path: "/firm/warehouses/employee-history",
        icon: History,
        module: "warehouseModule"
      },
      {
        label: "Personel Performans",
        path: "/firm/warehouses/employee-performance",
        icon: Gauge,
        module: "warehouseModule"
      },
      {
        label: "Depo Transfer/Giriş",
        path: "/firm/stock-movements",
        icon: ArrowLeftRight,
        module: "stockModule"
      },
    ]
  },
  {
    title: "Tanımlamalar",
    items: [
      { label: "Cariler", path: "/firm/customers", icon: Briefcase, module: "accountModule" },
      { label: "Stok Kartları", path: "/firm/stocks", icon: Boxes, module: "stockModule" },
      { label: "Kumaş Topları", path: "/firm/stock-rolls", icon: Boxes, module: "stockModule" },
      { label: "Kategori Tanımları", path: "/firm/category", icon: CardSimIcon, module: "stockModule" },
      { label: "Marka Tanımları", path: "/firm/brand", icon: BrickWallShieldIcon, module: "stockModule" },
      { label: "Personeller", path: "/firm/employee", icon: PersonStanding, module: "userModule" },
      { label: "Banka Hesapları", path: "/firm/banks", icon: BanknoteX, module: "financeModule" },
      { label: "Kasa Hesapları", path: "/firm/cashes", icon: Coins, module: "financeModule" },
      { label: "Depo Tanımları", path: "/firm/warehouses", icon: Warehouse, module: "warehouseModule" },
    ]
  },
  {
    title: "Saha Operasyonu",
    items: [
      { label: "Canlı Takip", path: "/firm/visit/monitor", icon: MapPin, module: "visitModule" },
      { label: "Rota Planlama", path: "/firm/visit/planner", icon: CalendarRange, module: "visitModule" },
      { label: "Ziyaret Raporları", path: "/firm/reports/visits", icon: ClipboardCheck, module: "visitModule" },
    ]
  },
  {
    title: "Cihazlar",
    items: [
      { label: "Yazıcı Yönetimi", path: "/firm/printers", icon: Printer, module: "stockModule" },
      { label: "Teraziler", path: "/firm/scale-devices", icon: Scale, module: "warehouseModule" },
      { label: "Etiket Tasarımları", path: "/firm/labels", icon: Tag, module: "syncModule" },
      { label: "Yazdırma Ayarları", path: "/firm/print-settings", icon: Settings2, module: "syncModule" },
    ]
  },
  {
    title: "Ayarlar",
    items: [
      { label: "Firma Ayarları", path: "/firm/settings", icon: Settings, module: "syncModule" },
      { label: "Sanal POS", path: "/firm/settings/sanalpos", icon: CreditCard, module: "syncModule" },
      { label: "E-Fatura", path: "/firm/settings/einvoice", icon: FileText, module: "syncModule" },
      { label: "Kargo", path: "/firm/settings/cargo", icon: Truck, module: "syncModule" },
      { label: "Rol Yönetimi", path: "/firm/roles", icon: Key, module: "userModule" },
    ]
  },
  {
    title: "Raporlar & Analiz",
    items: [
      { label: "Finans Raporları", path: "/firm/reports/finance", icon: Wallet, module: "financeModule" },
      { label: "Stok Raporları", path: "/firm/reports/stock", icon: ClipboardList, module: "stockModule" },
      { label: "Satış Analizleri", path: "/firm/reports/sales", icon: BarChart3, module: "orderModule" },
    ]
  }
];

const firmAdminMenu: MenuGroup[] = [
  ...firmAdminDashboardMenu,
  ...firmAdminOperationsAndDefinitionsMenu,
];

// --- 2. DİĞER ROLLERİN Menüleri ---

const adminMenu: MenuGroup[] = [
  {
    items: [
      { label: "Dashboard", path: "/dashboard", icon: LayoutDashboard },
    ]
  },
  {
    title: "Stok & Depo",
    items: [
      { label: "Depolar", path: "/warehouses", icon: Warehouse, module: "warehouseModule" },
      { label: "Stoklar", path: "/stocks", icon: Package, module: "stockModule" },
    ]
  },
  {
    title: "Finans",
    items: [
      { label: "Hesaplar", path: "/accounts", icon: Landmark, module: "accountModule" },
    ]
  }
];

const salesMenu: MenuGroup[] = [
  {
    title: "Satış Operasyonu",
    items: [
      { label: "Siparişler", path: "/orders", icon: ShoppingCart, module: "orderModule" },
      { label: "Müşteriler", path: "/customers", icon: UserCircle, module: "accountModule" },
      { label: "Satış Raporları", path: "/sales-reports", icon: ClipboardList, module: "orderModule" },
    ]
  }
];

const customerMenu: MenuGroup[] = [
  {
    items: [
      { label: "Siparişlerim", path: "/my-orders", icon: FileText, module: "orderModule" },
      { label: "Hesabım", path: "/account", icon: User },
    ]
  }
];

// --- 3. menuItems Ana Konfigürasyonu ---

export const menuItems: MenuConfig = {
  super_admin: [
    {
      title: "Sistem Yönetimi",
      items: [
        { label: "Dashboard (SA)", path: "/admin/dashboard", icon: LayoutDashboard },
        { label: "Firmalar", path: "/admin/firms", icon: Building },
        { label: "Firma Uygulamaları", path: "/admin/apps", icon: AppWindow },
        { label: "Ayar Tanımları", path: "/admin/setting-definition", icon: Settings2 },
        { label: "Kullanıcılar", path: "/admin/users", icon: Users },
        { label: "Birimler", path: "/admin/unit", icon: UndoDotIcon },
      ]
    },
    {
      title: "Gelişmiş Ayarlar",
      items: [
        { label: "Uygulama Tanımları", path: "/admin/integration/applications", icon: Settings2 },
        { label: "Roller", path: "/admin/roles", icon: Key },
      ]
    },
    ...firmAdminOperationsAndDefinitionsMenu,
  ],
  admin: adminMenu,
  firm_admin: firmAdminMenu,
  firm_sales: firmAdminMenu,
  customer: customerMenu,
};